var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.946777H2C1 0.946777 0 1.85717 0 2.96987V6.01461C0 6.74292 0.43 7.37008 1 7.72412V19.1546C1 20.2673 2.1 21.1777 3 21.1777H17C17.9 21.1777 19 20.2673 19 19.1546V7.72412C19.57 7.37008 20 6.74292 20 6.01461V2.96987C20 1.85717 19 0.946777 18 0.946777ZM13 13.0853H7V11.0622H13V13.0853ZM18 6.0045H2V2.96987H18V6.0045Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.e1f32a54440f098c0f61379e592b0c58.svg";
export { ForwardRef as ReactComponent };